var $imports = require("../../../../../node_modules/art-template/lib/runtime.js");
module.exports = function ($data) {
    'use strict';
    $data = $data || {};
    var $$out = '', $escape = $imports.$escape, pdfToWord = $data.pdfToWord, pdfToExcel = $data.pdfToExcel, pdfToPpt = $data.pdfToPpt, pdfToImg = $data.pdfToImg, exportAllImg = $data.exportAllImg, ocrPdfToPdf = $data.ocrPdfToPdf;
    $$out += '    <paddle exclude-devices="tablet" name="fv--fw-convert-tab-paddle">\n        <group-list name="convert-toolbar-group-list">\n            <group name="convert-tab-group-hand" retain-count="2">\n                <xbutton\n                  class="convert-item"\n                  name="hand-tool"\n                  @tooltip tooltip-title="手型工具"\n                  text=""\n                  icon-class="fv__icon-toolbar-hand"\n                  @controller="states:HandController">\n                </xbutton>\n                <div class="text-none text-have-more">\n                                <selection-ribbon-dropdown icon-class="fv__icon-toolbar-select"></selection-ribbon-dropdown>\n                            </div>\n                            <!-- <fw-module:fw-selection-button></fw-module:fw-selection-button> -->\n            </group>\n            <group>\n                <fw-module:fw-convert-to-pdf></fw-module:fw-convert-to-pdf>\n            </group>\n            <group name="convert-tab-group-to-file" retain-count="5">\n                <ribbon-button class="convert-item fv__ui-toolbar-show-text-button" name=';
    $$out += $escape(pdfToWord.name);
    $$out += ' @tooltip tooltip-title=';
    $$out += $escape(pdfToWord.title);
    $$out += ' icon-class=';
    $$out += $escape(pdfToWord.icon);
    $$out += ' text=';
    $$out += $escape(pdfToWord.title);
    $$out += '>';
    $$out += $escape(pdfToWord.title);
    $$out += '</ribbon-button>\n                <ribbon-button class="convert-item fv__ui-toolbar-show-text-button" name=';
    $$out += $escape(pdfToExcel.name);
    $$out += ' @tooltip tooltip-title=';
    $$out += $escape(pdfToExcel.title);
    $$out += ' icon-class=';
    $$out += $escape(pdfToExcel.icon);
    $$out += ' text=';
    $$out += $escape(pdfToExcel.title);
    $$out += '>';
    $$out += $escape(pdfToExcel.title);
    $$out += '</ribbon-button>\n                <ribbon-button class="convert-item fv__ui-toolbar-show-text-button" name=';
    $$out += $escape(pdfToPpt.name);
    $$out += ' @tooltip tooltip-title=';
    $$out += $escape(pdfToPpt.title);
    $$out += ' icon-class=';
    $$out += $escape(pdfToPpt.icon);
    $$out += ' text=';
    $$out += $escape(pdfToPpt.title);
    $$out += '>';
    $$out += $escape(pdfToPpt.title);
    $$out += '</ribbon-button>\n                <ribbon-button class="convert-item fv__ui-toolbar-show-text-button" name=';
    $$out += $escape(pdfToImg.name);
    $$out += ' @tooltip tooltip-title=';
    $$out += $escape(pdfToImg.title);
    $$out += ' icon-class=';
    $$out += $escape(pdfToImg.icon);
    $$out += ' text=';
    $$out += $escape(pdfToImg.title);
    $$out += '>';
    $$out += $escape(pdfToImg.title);
    $$out += '</ribbon-button>\n                <ribbon-button class="convert-item fv__ui-toolbar-show-text-button" name=';
    $$out += $escape(exportAllImg.name);
    $$out += ' @tooltip tooltip-title=';
    $$out += $escape(exportAllImg.title);
    $$out += ' icon-class=';
    $$out += $escape(exportAllImg.icon);
    $$out += ' text=';
    $$out += $escape(exportAllImg.title);
    $$out += '>';
    $$out += $escape(exportAllImg.title);
    $$out += '</ribbon-button>\n                <ribbon-button class="convert-item fv__ui-toolbar-show-text-button" name=';
    $$out += $escape(ocrPdfToPdf.name);
    $$out += ' @tooltip tooltip-title=';
    $$out += $escape(ocrPdfToPdf.title);
    $$out += ' icon-class=';
    $$out += $escape(ocrPdfToPdf.icon);
    $$out += ' text=';
    $$out += $escape(ocrPdfToPdf.title);
    $$out += '>';
    $$out += $escape(ocrPdfToPdf.title);
    $$out += '</ribbon-button>\n            </group>\n        </group-list>\n    </paddle>\n';
    return $$out;
};